export * from './feedbackForm.service';
import { FeedbackFormService } from './feedbackForm.service';
export * from './feedbackForm.serviceInterface';
export const APIS = [FeedbackFormService];
